import React from "react";
import { Interrogator, QuestionsObj } from "ewoq/containers/Interrogator";
import questions from "./Questions/LifestyleSleepQuestions";
import { answerQuestionnaire } from "ewoq/api";

interface Props {
  viewAll?: boolean;
  onDone?: () => void;
}

class LifestyleSleep extends React.Component<Props> {
  onSubmit = (answers: QuestionsObj) => {
    answerQuestionnaire("BIO", "Lifestyle-Sleep", { answers: answers });
    this.props.onDone && this.props.onDone();
  };

  render() {
    return (
      <div>
        <Interrogator
          questions={questions}
          onDone={this.onSubmit}
          viewAll={this.props.viewAll}
        />
      </div>
    );
  }
}

export default LifestyleSleep;
